<template>
  <a-modal
    :centered="true"
    :confirmLoading="confirmLoading"
    :destroy-on-close="true"
    :maskClosable="false"
    :visible="visible"
    width="9.9977rem"
    @cancel="handleCancel"
    class="teacher-modal"
    footer=""
  >
    <a-icon class="close-icon" slot="closeIcon"/>
    <div ref="modalSelectRoot"></div>
    <a-spin :spinning="confirmLoading" class="register-parent">
      <div class="teacher-modal-parent">
        <div class="teacher-item-img-parent">
          <img
            :src="record.attachmentList && record.attachmentList.length>0?baseUrl + record.attachmentList[0].url:''"
            class="teacher-item-img"/>
        </div>
        <div class="teacher-message">
          <div class="teacher-name">{{ record.name }}</div>
          <div class="teacher-title">{{ record.employer }}-{{ record.title }}</div>
          <div class="teacher-remark">{{ record.remarks }}</div>
        </div>
      </div>
    </a-spin>
  </a-modal>
</template>
<script>
  import teacher from '../../api/teacher'

  export default {
    name: 'TeacherModal',
    props: {},
    components: {},
    data() {
      return {
        baseUrl: process.env.VUE_APP_BASE_URL,
        visible: false,
        record: {},
        confirmLoading: false,
        id: ''
      }
    },
    beforeCreate() {
    },
    created() {
    },
    mounted() {
    },
    methods: {
      handleCancel() {
        this.visible = false
      },
      show(id) {
        this.record = {}
        this.visible = true
        this.id = id
        this.confirmLoading = true
        teacher.getTeacher({id: this.id}).then(res => {
          this.record = res.result
          setTimeout(() => {
            this.confirmLoading = false
          }, 500)
        })
      }
    },
    watch: {}
  }
</script>
<style lang="less">
  .teacher-modal {

    .close-icon {
      display: inline-block;
      width: 0.15rem;
      height: 0.15rem;
      background: url('../../assets/icons/ic_login_close@2x.png')  center/100% 100% no-repeat;
    }

    .ant-modal-content {
      border-radius: 0.0975rem;
    }

    .ant-modal-header {
      border: 0; // 去掉标题下面的线
      border-radius: 0.0975rem 0.0975rem 0 0;
    }

    .teacher-modal-parent {
      display: flex;

      .teacher-item-img-parent {
        height: auto;
        display: flex;
        align-items: center;
      }

      .teacher-item-img {
        width: 2.7226rem;
        height: 3.1951rem;
        border-radius: 0.0375rem;
        object-fit: cover;
      }

      .teacher-message {
        padding: 0.24rem 0.255rem;

        .teacher-name {
          font-weight: 600;
          color: #191d28;
          font-size: 0.24rem;
          letter-spacing: 0.002rem;
          line-height: 0.3rem;
        }

        .teacher-title {
          color: #79818d;
          font-size: 0.15rem;
          line-height: 0.22rem;
          margin-top: 0.0675rem;
        }

        .teacher-remark {
          margin-top: 0.195rem;
          color: #79818d;
          font-size: 0.15rem;
          line-height: 0.22rem;
          white-space: pre-wrap;
        }
      }
    }
  }
</style>
